/* ═══════════════════════════════════════════════════════════
   DARF — Header: mobile drawer + search overlay
   Depends on: darf-utils.js
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var u = window.DarfUtils;
  if (!u) return;

  var $ = u.$, $$ = u.$$, on = u.on;

  /* ── Mobile drawer ──────────────────────────────────────── */
  var overlay  = document.getElementById('drawer-overlay');
  var drawer   = document.getElementById('site-drawer');
  var burger   = document.getElementById('burger-btn');
  var closeBtn = document.getElementById('drawer-close');

  /* iOS-safe scroll lock: preserves scroll position, prevents underlying scroll */
  var _scrollY = 0;
  function lockScroll() {
    _scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + _scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, _scrollY);
  }

  /* Focus trap utility — restricts Tab/Shift+Tab to within a container */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function makeTrap(container) {
    var prevFocus = null;
    function handler(e) {
      if (e.key !== 'Tab') return;
      var nodes = Array.from(container.querySelectorAll(FOCUSABLE)).filter(function(n){ return !n.hasAttribute('hidden') && n.offsetParent !== null; });
      if (!nodes.length) return;
      var first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    return {
      activate: function(){
        prevFocus = document.activeElement;
        document.addEventListener('keydown', handler);
        setTimeout(function(){
          var first = container.querySelector(FOCUSABLE);
          if (first) try { first.focus(); } catch(_){}
        }, 60);
      },
      release: function(){
        document.removeEventListener('keydown', handler);
        if (prevFocus && prevFocus.focus) try { prevFocus.focus(); } catch(_){}
      }
    };
  }
  var drawerTrap = drawer ? makeTrap(drawer) : null;

  function openDrawer()  {
    drawer  && drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    if (drawer) {
      drawer.setAttribute('aria-modal', 'true');
      drawer.setAttribute('role', 'dialog');
    }
    lockScroll();
    drawerTrap && drawerTrap.activate();
  }
  function closeDrawer() {
    drawer  && drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    if (drawer) drawer.removeAttribute('aria-modal');
    unlockScroll();
    drawerTrap && drawerTrap.release();
  }

  on(burger,   'click', openDrawer);
  on(closeBtn, 'click', closeDrawer);
  on(overlay,  'click', closeDrawer);

  /* Sub-menu accordion in drawer */
  $$('[data-drawer-toggle]').forEach(function (btn) {
    on(btn, 'click', function () {
      var targetId = btn.dataset.drawerToggle;
      var sub = document.getElementById(targetId);
      var isOpen = sub && sub.classList.contains('is-open');
      $$('.drawer__sub').forEach(function (s) { s.classList.remove('is-open'); });
      $$('[data-drawer-toggle]').forEach(function (l) { l.classList.remove('is-open'); });
      if (!isOpen && sub) { sub.classList.add('is-open'); btn.classList.add('is-open'); }
    });
  });

  /* ── Search overlay ─────────────────────────────────────── */
  var searchOverlay = document.getElementById('search-overlay');
  var searchInput   = document.getElementById('search-input');

  var searchTrap = searchOverlay ? makeTrap(searchOverlay) : null;
  function openSearch() {
    searchOverlay && searchOverlay.classList.add('is-open');
    if (searchOverlay) {
      searchOverlay.setAttribute('aria-modal', 'true');
      searchOverlay.setAttribute('role', 'dialog');
    }
    lockScroll();
    setTimeout(function () { searchInput && searchInput.focus(); }, 80);
    searchTrap && searchTrap.activate();
  }
  function closeSearch() {
    searchOverlay && searchOverlay.classList.remove('is-open');
    if (searchOverlay) searchOverlay.removeAttribute('aria-modal');
    unlockScroll();
    searchTrap && searchTrap.release();
  }

  $$('[data-open-search]').forEach(function (btn) { on(btn, 'click', openSearch); });
  $$('[data-search-close]').forEach(function (btn) { on(btn, 'click', closeSearch); });
  on(searchOverlay, 'click', function (e) {
    if (e.target === searchOverlay || e.target.dataset.searchClose !== undefined) closeSearch();
  });

  /* ── Global Escape key ──────────────────────────────────── */
  on(document, 'keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    closeSearch();
    if (window.DarfCart) window.DarfCart.close();
    unlockScroll();
  });

  /* Expose scroll lock for cart drawer + other modules */
  window.DarfScrollLock = { lock: lockScroll, unlock: unlockScroll };

  /* Expose for other modules */
  window.DarfHeader = { openDrawer: openDrawer, closeDrawer: closeDrawer, openSearch: openSearch, closeSearch: closeSearch };
})();
